"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoader = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Loader_1 = require("./Loader");
function useLoader(_a = {
    loading: false,
    Component: Loader_1.Loader,
}) {
    var { Component, loading } = _a, props = tslib_1.__rest(_a, ["Component", "loading"]);
    const [loadingState, setLoading] = react_1.useState(loading || false);
    if (!Component) {
        Component = Loader_1.Loader;
    }
    const loader = loadingState ? jsx_runtime_1.jsx(Component, Object.assign({}, props), void 0) : null;
    return {
        loader,
        setLoading,
        loading: loadingState,
    };
}
exports.useLoader = useLoader;
//# sourceMappingURL=useLoader.js.map